// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"d3deb839","796":"918cab42"}[chunkId] + ".chunk.js";
};